import "./MobileAccountAside.scss";
import { useRecoilState } from "recoil";
import { memberState } from "../../state/atoms";
import UserBadge from "../UserBadge";
import { NavLink } from "react-router-dom";
import { env } from "../../env/env";
import { Button } from "../account/misc/Button";
import { HomeOutlined, QuestionCircleOutlined, PhoneOutlined } from "@ant-design/icons";
import PricingIcon from "../icons/PricingIcon";
import MobileTemplatesDropdown from "./MobileTemplatesDropdown";
import MobileDigitalDropdown from "./MobileDigitalDropdown";
import {logout} from "../../service/AuthService";

export interface MobileAccountAsideProps {
  closeDrawer: () => void;
}

export default function MobileAccountAside({closeDrawer} : MobileAccountAsideProps) {
  const [member] = useRecoilState(memberState);

  function goToTeam() {
    window.location.href = env.dashboardPath + "/account/team";
  }

  function goToSettings() {
    window.location.href = env.dashboardPath + "/account/users";
  }

  function goToLocations() {
    window.location.href = env.dashboardPath + "/account/locations";
  }

  function bookDemoClick() {
    window.open('/feature/book-demo-auth.html', '_blank');
  }

  return (
    <div className={"act-sub-menu"}>
      <div className={"id-card"}>
        <UserBadge name={member.name} />
        <h5>{member.name}</h5>
        <h6>{member.email}</h6>
      </div>

      {member.owner && <div className="user-loc-btns">
        <Button onClick={goToTeam} className={"small team-btn"}>
          My Team
        </Button>
        <Button onClick={goToLocations} className={"small loc-btn"}>
          My Locations
        </Button>
      </div>}
      <div className="full-btn">
        <Button onClick={goToSettings} className={"small act-btn"}>
          Account Settings
        </Button>
      </div>

      <ul>
        <div className="separator"/>
        <li>
          <NavLink
            to={`${env.dashboardPath}/designs`} onClick={closeDrawer}
          >
            <HomeOutlined />
            Home
          </NavLink>
        </li>
        <MobileTemplatesDropdown closeDrawer={closeDrawer} />
        <MobileDigitalDropdown closeDrawer={closeDrawer} />
        <li className={"wide-svg"}>
          <a href={"/menu/pricing.do"} onClick={closeDrawer}>
            <PricingIcon />
            Pricing
          </a>
        </li>

        <div className="separator"/>

        <li className="help-svg">
          <a href={"https://intercom.help/musthavemenus-289b0117ae34/en"} rel="external" onClick={closeDrawer}>
            <QuestionCircleOutlined />
            Help Center
          </a>
        </li>
        <li>
          <a href={"/menu/contact.do"} onClick={closeDrawer}>
            <PhoneOutlined />
            Contact Us
          </a>
        </li>
        <li className="wide-svg">
          <a href={"/menu/logoff.do"} onClick={() => { logout(); closeDrawer();}}>
            <img className="signout-icon" src="https://timber.mhmcdn.com/site/marketing/icons/User.svg" alt="Sign Out"/>
            Sign Out
          </a>
        </li>
      </ul>
      <div className="full-btn demo-btn">
        <Button onClick={bookDemoClick} className={"primary"}>
          Book a Demo
        </Button>
      </div>
    </div>
  );
}
